import { useCallback } from "react";
import type { MetricFormatConfiguration } from "../../../../api/portfolioMonitoringTypes";
import { formatMetricMoneyValue } from "../../../../utilities/metricFormatters";
import NumberTextField from "../../../inputs/NumberTextField";

interface Props {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  currencyCode: string;
  formatConfig?: MetricFormatConfiguration;
  readOnly?: boolean;
  disabled?: boolean;
}

const MetricMoneyField = ({ value, onChange, currencyCode, formatConfig, readOnly, disabled }: Props) => {
  const valueFormatter = useCallback(
    (value: number) => formatMetricMoneyValue(value, currencyCode, formatConfig),
    [currencyCode, formatConfig]
  );

  return (
    <NumberTextField
      fullWidth
      disabled={disabled}
      numberValue={value}
      onNumberChange={onChange}
      valueFormatter={valueFormatter}
      sx={{ bgcolor: readOnly ? "background.grey" : undefined }}
    />
  );
};

export default MetricMoneyField;
